export const translations = {
  fa: {
    // Navigation
    nav: {
      dashboard: "داشبورد",
      trades: "ژورنال معاملات",
      analytics: "تحلیل عملکرد",
      riskManagement: "حاکمیت ریسک",
      calendar: "تقویم",
      strategies: "استراتژی‌ها",
      fundamentals: "فاندامنتال",
      tradeAssistant: "دستیار معاملاتی",
      settings: "تنظیمات",
    },
    // Common
    common: {
      save: "ذخیره",
      cancel: "انصراف",
      edit: "ویرایش",
      delete: "حذف",
      add: "افزودن",
      search: "جستجو",
      filter: "فیلتر",
      export: "خروجی",
      import: "ورودی",
      all: "همه",
      open: "باز",
      closed: "بسته",
      buy: "خرید",
      sell: "فروش",
      profit: "سود",
      loss: "ضرر",
      total: "مجموع",
      average: "میانگین",
      items: "مورد",
      from: "از",
      to: "تا",
      date: "تاریخ",
      time: "زمان",
      notes: "یادداشت",
      tags: "برچسب‌ها",
      actions: "عملیات",
      status: "وضعیت",
      details: "جزئیات",
      loading: "در حال بارگذاری...",
      noData: "داده‌ای یافت نشد",
      confirm: "تأیید",
      back: "بازگشت",
      next: "بعدی",
      previous: "قبلی",
      yes: "بله",
      no: "خیر",
      error: "خطا",
    },
    // Dashboard
    dashboard: {
      title: "داشبورد",
      subtitle: "خلاصه عملکرد معاملاتی شما",
      totalTrades: "تعداد معاملات",
      winRate: "نرخ موفقیت",
      winningTrades: "معاملات برنده",
      profitFactor: "فاکتور سود",
      totalProfitLoss: "سود/ضرر کل",
      avgWin: "میانگین سود",
      avgLoss: "میانگین ضرر",
      expectancy: "امید ریاضی",
      maxDrawdown: "حداکثر افت سرمایه",
      equityCurve: "منحنی سرمایه",
      rDistribution: "توزیع R",
      performanceBySymbol: "عملکرد بر اساس نماد",
      recentTrades: "معاملات اخیر",
      streaksTitle: "آمار استریک‌ها",
      currentStreak: "استریک فعلی",
      longestWin: "طولانی‌ترین برد",
      longestLoss: "طولانی‌ترین باخت",
      warningTotalOpenRisk: "هشدار: مجموع ریسک باز",
      warningOpenTrades: "تعداد معاملات باز",
    },
    // Trades
    trades: {
      title: "ژورنال معاملات",
      subtitle: "مدیریت و تحلیل معاملات",
      newTrade: "معامله جدید",
      addTrade: "ثبت معامله",
      searchPairPlaceholder: "جستجوی جفت‌ارز...",
      noTradesFiltered: "هیچ معامله‌ای با فیلترهای انتخابی یافت نشد",
      noTradesYet: "هیچ معامله‌ای ثبت نشده است",
      notesPlaceholder: "یادداشت‌های معامله...",
      editTrade: "ویرایش معامله",
      tradeDetails: "جزئیات معامله",
      pair: "جفت ارز",
      type: "نوع",
      direction: "جهت",
      orderType: "نوع سفارش",
      entryPrice: "قیمت ورود",
      exitPrice: "قیمت خروج",
      stopLoss: "حد ضرر",
      takeProfit: "حد سود",
      lotSize: "حجم (لات)",
      pips: "پیپ",
      profitLoss: "سود/ضرر",
      rMultiple: "ضریب R",
      commission: "کمیسیون",
      swap: "سوآپ",
      fees: "کارمزد",
      slippage: "اسلیپیج",
      entryDate: "تاریخ ورود",
      exitDate: "تاریخ خروج",
      session: "سشن",
      strategy: "استراتژی",
      setup: "ستاپ",
      market: "مارکت",
      limit: "لیمیت",
      stop: "استاپ",
      asia: "آسیا",
      london: "لندن",
      ny: "نیویورک",
      overlap: "همپوشانی",
      importedFromMt: "این دادها از MetaTrader وارد شدهاند",
      userInputHint: "این دادها را شما وارد میکنید",
      ticket: "تیکت",
      duration: "مدت زمان",
      marketCondition: "شرایط بازار",
      quantitativeData: "داده‌های کمی (خودکار از MT)",
      qualitativeData: "داده‌های کیفی (ورودی شما)",
      clickToExpand: "برای مشاهده جزئیات کلیک کنید",
      viewDetails: "مشاهده جزئیات",
      disciplineScore: "امتیاز نظم",
      slTpAdjustment: "تعدیل SL/TP",
      finalOutcome: "نتیجه نهایی",
      priceReversalIllusion: "توهم بازگشت قیمت",
      strategyUsed: "استراتژی استفاده شده",
      lessonsLearned: "درسهای آموخته شده",
      connectMetaTrader: "برای دریافت معاملات، MetaTrader را متصل کنید",
      webhookUrl: "آدرس Webhook",
      openPositions: "معاملات باز",
      closedPositions: "معاملات بسته شده",
      floatingPnl: "سود/ضرر شناور",
      realizedPnl: "سود/ضرر تحقق‌یافته",
      eventTimeline: "تایم‌لاین رویدادها",
      platform: "پلتفرم",
      webhookSecret: "کلید امنیتی Webhook",
    },
    // Psychology & Qualitative
    psychology: {
      title: "روانشناسی معامله",
      emotionOpen: "احساس هنگام ورود",
      emotionClose: "احساس هنگام خروج",
      reasonOpen: "دلیل ورود به معامله",
      reasonClose: "دلیل خروج از معامله",
      reasonOpenPlaceholder: "چرا وارد این معامله شدید؟",
      reasonClosePlaceholder: "چرا از این معامله خارج شدید؟",
      followedPlan: "طبق پلن عمل شد؟",
      mistakes: "اشتباهات",
      mistakesPlaceholder: "چه اشتباهاتی انجام دادید؟",
      lessons: "درسهای آموخته شده",
      satisfaction: "میزان رضایت",
      confidence: "میزان اعتماد به نفس",
      stress: "میزان استرس",
      fomo: "ترس از دست دادن فرصت (FOMO)",
      revenge: "معامله انتقامی بود؟",
      overtrading: "معامله بیش از حد بود؟",
      emotionScale: {
        veryBad: "خیلی بد",
        bad: "بد",
        neutral: "معمولی",
        good: "خوب",
        veryGood: "خیلی خوب",
      },
      reflection: "بازتاب و تحلیل",
      whatWorked: "چه چیزی خوب بود؟",
      whatDidntWork: "چه چیزی خوب نبود؟",
      improvement: "نکات بهبود",
    },
    // Risk Management
    risk: {
      title: "مدیریت ریسک",
      subtitle: "محاسبه و کنترل ریسک",
      positionCalculator: "محاسبه‌گر اندازه پوزیشن",
      accountBalance: "موجودی حساب",
      riskPercent: "ریسک (%)",
      riskAmount: "مقدار ریسک",
      stopDistance: "فاصله حد ضرر (پیپ)",
      positionSize: "اندازه پوزیشن",
      potentialLoss: "ضرر احتمالی",
      potentialProfit: "سود احتمالی",
      riskReward: "نسبت ریسک به ریوارد",
      portfolioHeat: "ریسک پرتفوی",
      portfolioStatus: "وضعیت پرتفولیو",
      maxDailyLoss: "حداکثر ضرر روزانه",
      maxWeeklyLoss: "حداکثر ضرر هفتگی",
      openPositions: "معاملات باز",
      totalOpenRisk: "مجموع ریسک باز",
      kellyFraction: "معیار کلی",
      kellyRecommended: "Half Kelly (توصیه شده)",
      kellyNote: "Kelly Criterion بر اساس عملکرد تاریخی شما محاسبه شده است. استفاده از نصف Kelly برای محافظه‌کاری بیشتر توصیه می‌شود.",
      calculate: "محاسبه",
      suggestedSize: "اندازه پوزیشن پیشنهادی",
      riskWarning: "هشدار ریسک بالا!",
      riskWarningText: "مجموع ریسک معاملات باز",
      pair: "جفت‌ارز",
      entryPrice: "قیمت ورود",
      avgWinLoss: "نسبت میانگین سود/ضرر",
    },
    // Analytics
    analytics: {
      title: "تحلیل عملکرد",
      subtitle: "تحلیل عمیق معاملات و عملکرد",
      byStrategy: "بر اساس استراتژی",
      bySession: "بر اساس سشن",
      byDay: "بر اساس روز هفته",
      bySymbol: "بر اساس نماد",
      byEmotion: "بر اساس احساسات",
      winningTrades: "معاملات موفق",
      losingTrades: "معاملات ناموفق",
      breakeven: "سربه‌سر",
      streaks: "سری‌ها",
      bestTrade: "بهترین معامله",
      worstTrade: "بدترین معامله",
      strategyPerformance: "عملکرد به تفکیک استراتژی",
      sessionPerformance: "عملکرد به تفکیک سشن",
      weekdayPerformance: "عملکرد به تفکیک روز هفته",
      noStrategy: "بدون استراتژی",
      unknown: "نامشخص",
      trades: "معامله",
    },
    // Calendar
    calendar: {
      title: "تقویم معاملاتی",
      subtitle: "مرور روزانه عملکرد معاملاتی",
      daily: "روزانه",
      weekly: "هفتگی",
      monthly: "ماهانه",
      tradesCount: "تعداد معاملات",
      dayPnL: "سود/ضرر روز",
      totalR: "مجموع R",
      noTrades: "هیچ معامله‌ای برای نمایش وجود ندارد",
    },
    // Strategies
    strategies: {
      title: "کتابخانه استراتژی",
      subtitle: "مدیریت و مشاهده استراتژی‌های معاملاتی",
      newStrategy: "استراتژی جدید",
      checklist: "چک‌لیست",
      entryRules: "ورود",
      exitRules: "خروج",
      timeframes: "تایم‌فریم‌ها",
      examples: "نمونه‌ها",
    },
    // Fundamentals
    fundamentals: {
      title: "فاندامنتال",
      subtitle: "تحلیل بنیادی بازارها با هوش مصنوعی",
      economicCalendar: "تقویم اقتصادی",
      fedWatch: "نظارت فدرال رزرو",
      macroData: "داده‌های کلان",
      news: "اخبار",
      highImpact: "تأثیر بالا",
      mediumImpact: "تأثیر متوسط",
      lowImpact: "تأثیر پایین",
      // New keys
      marketOverview: "نمای کلی بازار",
      fredIndicators: "شاخص‌های فدرال رزرو",
      newsAnalysis: "تحلیل اخبار",
      aiOutlook: "چشم‌انداز AI",
      generateAnalysis: "تولید تحلیل",
      refreshData: "بروزرسانی",
      lastUpdated: "آخرین بروزرسانی",
      bullish: "صعودی",
      bearish: "نزولی",
      neutral: "خنثی",
      confidence: "اطمینان",
      forex: "فارکس",
      gold: "طلا",
      oil: "نفت",
      crypto: "کریپتو",
      allMarkets: "همه بازارها",
      realtime: "لحظه‌ای",
      daily: "روزانه",
      weekly: "هفتگی",
      keyDrivers: "محرک‌های کلیدی",
      risks: "ریسک‌ها",
      predictions: "پیش‌بینی‌ها",
      target: "هدف",
      support: "حمایت",
      resistance: "مقاومت",
      rising: "افزایشی",
      declining: "کاهشی",
      stable: "ثابت",
      hawkish: "انقباضی",
      dovish: "انبساطی",
      strong: "قوی",
      weak: "ضعیف",
      geopoliticalRisks: "ریسک‌های ژئوپلیتیک",
      upcomingEvents: "رویدادهای پیش رو",
      tradingBias: "سوگیری معاملاتی",
      buy: "خرید",
      sell: "فروش",
      hold: "نگه‌داری",
      noAnalysis: "هنوز تحلیلی انجام نشده",
      clickGenerate: "برای تولید تحلیل روی دکمه بروزرسانی کلیک کنید",
      analyzing: "در حال تحلیل...",
      errorLoading: "خطا در بارگذاری داده‌ها",
      mockDataWarning: "شاخص‌های اقتصادی FRED از داده‌های نمونه استفاده می‌کنند (FRED API Key تنظیم نشده)",
      newsIsReal: "اخبار و تحلیل‌های AI از منابع واقعی دریافت می‌شوند",
      // New tabs
      tabs: {
        fredIndicators: "شاخص‌های فدرال",
        calendarUSD: "تقویم USD",
        marketPrices: "قیمت‌های لحظه‌ای",
        centralBanks: "بانک‌های مرکزی",
        economicNews: "اخبار اقتصادی",
        wars: "جنگ‌ها و تنش‌ها",
        speeches: "سخنرانی‌ها",
        aiAnalysis: "تحلیل AI",
      },
      // Market prices
      prices: {
        crypto: "ارزهای دیجیتال",
        indices: "شاخص‌های بورس",
        commodities: "کالاها",
        currencies: "ارزها",
      },
      // Central banks
      centralBanks: {
        title: "بانک‌های مرکزی جهان",
        rate: "نرخ بهره",
        nextMeeting: "جلسه بعدی",
        stance: "موضع",
      },
      // Geopolitical
      geopolitical: {
        currentWars: "جنگ‌های جاری",
        economicChallenges: "چالش‌های اقتصادی",
        leaderSpeeches: "سخنرانی رهبران",
        severity: "شدت",
        critical: "بحرانی",
        serious: "جدی",
        moderate: "متوسط",
        riskLevel: "سطح ریسک",
        increasing: "افزایشی",
        decreasing: "کاهشی",
      },
      // Auto refresh
      autoRefresh: "بروزرسانی خودکار",
      autoRefreshEnabled: "هر ۵ دقیقه",
      dataUpdated: "داده‌ها بروز شدند",
    },
    // Trade Assistant
    assistant: {
      title: "دستیار معاملاتی",
      subtitle: "اتصال به MetaTrader و اجرای معاملات",
      connectionStatus: "وضعیت اتصال",
      connected: "متصل",
      disconnected: "قطع",
      connecting: "در حال اتصال...",
      mtAccount: "حساب MetaTrader",
      syncTrades: "همگامسازی معاملات",
      lastSync: "آخرین همگامسازی",
      pendingSync: "در انتظار همگامسازی",
      importFromMT: "وارد کردن از MT",
      quantitativeData: "دادههای کمی (از MT)",
      qualitativeData: "دادههای کیفی (ورودی شما)",

      connectionHelp: "برای اتصال به MetaTrader، باید EA Bridge را روی پلتفرم معاملاتی خود نصب کنید.",
      connectToMt: "اتصال به MT",
      connectionSettings: "تنظیمات اتصال",

      howItWorks: "نحوه کار",
      automatic: "خودکار",
      yourInput: "ورودی شما",

      autoItems: {
        entryExit: "قیمت ورود و خروج",
        slTp: "حد ضرر و حد سود",
        lotSize: "حجم معامله (لات)",
        pl: "سود/ضرر به دلار و پیپ",
        fees: "کمیسیون، سواپ و کارمزد",
        dateTime: "تاریخ و زمان معامله",
      },
      inputItems: {
        reasonEntry: "دلیل ورود به معامله",
        reasonExit: "دلیل خروج از معامله",
        emotions: "احساسات هنگام معامله",
        followedPlan: "آیا طبق پلن عمل شد؟",
        mistakesLessons: "اشتباهات و درسها",
        notesTags: "یادداشتها و برچسبها",
      },

      importTradesTitle: "وارد کردن معاملات",
      importTradesDesc: "تا زمان برقراری اتصال با MetaTrader، میتوانید معاملات را به صورت دستی از فایل CSV وارد کنید.",
      importFromMt45: "وارد کردن از MT4/MT5",
      downloadCsvTemplate: "دانلود قالب CSV",
      // New keys for Trade Assistant page
      openPositions: "پوزیشن‌های باز",
      noOpenPositions: "پوزیشن باز ندارید",
      connectAccount: "اتصال حساب",
      connectAccountMessage: "برای استفاده از دستیار معاملاتی، ابتدا حساب MetaTrader خود را متصل کنید.",
      kpi: {
        dailyDD: "DD روزانه",
        riskUtil: "استفاده ریسک",
        margin: "مارجین",
        heat: "حرارت",
        nextNews: "خبر بعدی",
      },
      actions: {
        close: "بستن",
        closePosition: "بستن پوزیشن",
        reduce: "کاهش",
        reduce50: "کاهش ۵۰٪",
        protect: "محافظت",
        protectBE: "محافظت (BE)",
        modifySL: "تغییر SL",
        modifyTP: "تغییر TP",
      },
      modes: {
        title: "حالت اتوپایلت",
        safe: "امن",
        discipline: "نظم",
        adaptive: "تطبیقی",
        pro: "حرفه‌ای",
        custom: "سفارشی",
      },
      runbooks: {
        title: "رانبوک‌ها",
        drawdownSpike: "محافظ جهش Drawdown",
        marginRescue: "نجات مارجین",
        newsLockdown: "قفل اخبار",
        slProximity: "نگهبان نزدیکی SL",
        exposureControl: "کنترل اکسپوژر",
        timeBasedExit: "خروج زمان‌بندی",
      },
      killSwitch: {
        title: "کیل سوئیچ",
        stage: "مرحله",
        none: "غیرفعال",
        stage1: "مرحله ۱",
        stage2: "مرحله ۲",
        trigger: "فعال‌سازی",
        reset: "ریست",
        lockedUntil: "قفل تا",
        confirmTitle: "فعال‌سازی کیل سوئیچ",
        confirmMessage: "این عمل تمام پوزیشن‌های باز را می‌بندد. آیا مطمئن هستید؟",
      },
      logs: {
        title: "لاگ عملیات",
        noEvents: "هیچ رویدادی ثبت نشده",
        queued: "در صف",
        executed: "اجرا شد",
        runbook: "رانبوک",
      },
      status: {
        normal: "عادی",
        watch: "هشدار",
        danger: "خطر",
      },
      heat: {
        low: "کم",
        medium: "متوسط",
        high: "زیاد",
      },
    },
    // Settings
    settings: {
      title: "تنظیمات",
      subtitle: "تنظیمات اپلیکیشن و معاملات",
      language: "زبان",
      theme: "تم",
      dark: "تیره",
      light: "روشن",
      auto: "خودکار",
      timezone: "منطقه زمانی",
      currency: "واحد پول",
      accounts: "حسابها",
      backup: "پشتیبانگیری",
      restore: "بازیابی",
      exportData: "خروجی دادهها",
      importData: "ورودی دادهها",
      invalidFile: "فایل نامعتبر است",
      backupRestoreTitle: "پشتیبانگیری و بازیابی",
      languages: {
        fa: "فارسی",
        en: "انگلیسی",
      },
      appSettingsTitle: "تنظیمات اپلیکیشن",
      timezoneLabel: "منطقه زمانی",
      timezoneDesc: "منطقه زمانی پیش‌فرض برای نمایش تاریخ‌ها",
      notifications: "اعلان‌ها",
      inAppNotif: "اعلان داخل اپ",
      emailNotif: "اعلان ایمیلی",
      uiPreferences: "ترجیحات ظاهری",
      compactMode: "حالت فشرده",
      compactModeDesc: "نمایش فشرده‌تر جداول و لیست‌ها",
      tradingSettingsTitle: "تنظیمات معاملاتی",
      noActiveAccount: "برای مشاهده تنظیمات ترید، ابتدا یک حساب معاملاتی را در بخش اتصالات فعال کنید.",
      goToConnections: "رفتن به اتصالات",
      defaultRiskMode: "حالت ریسک پیش‌فرض",
      fixedAmount: "مبلغ ثابت ($)",
      percentEquity: "درصد اکوئیتی (%)",
      defaultSymbol: "نماد پیش‌فرض",
      defaultSymbolPlaceholder: "مثلاً XAUUSD",
      slAlerts: "هشدارهای حد ضرر",
      slAlertsDesc: "دریافت هشدار وقتی قیمت به درصد مشخصی از حد ضرر نزدیک می‌شود",
      slAlert60: "هشدار در ۶۰٪ حد ضرر",
      slAlert80: "هشدار در ۸۰٪ حد ضرر",
      slAlert90: "هشدار در ۹۰٪ حد ضرر",
      journalDefaults: "پیش‌فرض‌های ژورنال",
      journalDefaultsDesc: "تنظیمات پیش‌فرض برای ثبت معاملات جدید (به زودی)",
      importBehavior: "رفتار ایمپورت ترید",
      importBehaviorDesc: "نحوه وارد کردن معاملات از MetaTrader",
      closedOnly: "فقط تریدهای بسته شده",
      closedOnlyDesc: "فعلاً فقط تریدهای بسته شده از متاتریدر وارد می‌شوند",
      saved: "ذخیره شد",
      settingsSaved: "تنظیمات با موفقیت ذخیره شد",
      mtConnectionTitle: "اتصال به MetaTrader",
      mtConnectionDesc: "برای اتصال به MetaTrader، به بخش اتصالات مراجعه کنید.",
      goToAssistant: "رفتن به دستیار معاملاتی",
      mtConnectionSection: "اتصال به MetaTrader",
      webhookUrl: "آدرس Webhook",
      copyWebhookUrl: "کپی آدرس",
      userId: "شناسه کاربری",
      copyUserId: "کپی شناسه",
      eaTemplate: "قالب اکسپرت متاتریدر",
      copyEaCode: "کپی کد EA",
      viewCode: "نمایش کد",
      hideCode: "مخفی کردن کد",
      connectionStatus: "وضعیت اتصال",
      howItWorks: "نحوه کار",
      importTrades: "وارد کردن معاملات",
      userIdDesc: "شناسه کاربری شما",
      webhookDesc: "این آدرس را در Expert Advisor متاتریدر استفاده کنید.",
      eaDesc: "این کد را در MetaEditor کپی کنید.",
      eaImportant: "مهم: URL وب‌هوک را به لیست مجاز اضافه کنید.",
      examplePayload: "نمونه داده JSON",
      comingSoon: "به زودی",
      goToMtSettings: "رفتن به تنظیمات MetaTrader",
      lastSync: "آخرین همگام‌سازی",
      totalSyncedTrades: "تعداد معاملات همگام شده",
      neverSynced: "هنوز همگام‌سازی نشده",
      checkingStatus: "در حال بررسی...",
      recentlyActive: "فعال (۲۴ ساعت اخیر)",
      inactive: "غیرفعال",
      refreshStatus: "بررسی مجدد",
      selectPlatform: "انتخاب پلتفرم",
      mt4Description: "برای متاتریدر ۴ (MQL4)",
      mt5Description: "برای متاتریدر ۵ (MQL5)",
      testConnection: "تست اتصال",
      testConnectionDesc: "یک معامله تستی برای بررسی صحت اتصال ارسال می‌شود",
    },
  },
  en: {
    // Navigation
    nav: {
      dashboard: "Dashboard",
      trades: "Trade Journal",
      analytics: "Analytics",
      riskManagement: "Risk Management",
      calendar: "Calendar",
      strategies: "Strategies",
      fundamentals: "Fundamentals",
      tradeAssistant: "Trade Assistant",
      settings: "Settings",
    },
    // Common
    common: {
      save: "Save",
      cancel: "Cancel",
      edit: "Edit",
      delete: "Delete",
      add: "Add",
      search: "Search",
      filter: "Filter",
      export: "Export",
      import: "Import",
      all: "All",
      open: "Open",
      closed: "Closed",
      buy: "Buy",
      sell: "Sell",
      profit: "Profit",
      loss: "Loss",
      total: "Total",
      average: "Average",
      items: "items",
      from: "From",
      to: "To",
      date: "Date",
      time: "Time",
      notes: "Notes",
      tags: "Tags",
      actions: "Actions",
      status: "Status",
      details: "Details",
      loading: "Loading...",
      noData: "No data found",
      confirm: "Confirm",
      back: "Back",
      next: "Next",
      previous: "Previous",
      yes: "Yes",
      no: "No",
      error: "Error",
    },
    // Dashboard
    dashboard: {
      title: "Dashboard",
      subtitle: "Your trading performance summary",
      totalTrades: "Total Trades",
      winRate: "Win Rate",
      winningTrades: "Winning Trades",
      profitFactor: "Profit Factor",
      totalProfitLoss: "Total P/L",
      avgWin: "Avg Win",
      avgLoss: "Avg Loss",
      expectancy: "Expectancy",
      maxDrawdown: "Max Drawdown",
      equityCurve: "Equity Curve",
      rDistribution: "R Distribution",
      performanceBySymbol: "Performance by Symbol",
      recentTrades: "Recent Trades",
      streaksTitle: "Streaks",
      currentStreak: "Current Streak",
      longestWin: "Longest Win",
      longestLoss: "Longest Loss",
      warningTotalOpenRisk: "Warning: Total open risk is",
      warningOpenTrades: "Open trades",
    },
    // Trades
    trades: {
      title: "Trade Journal",
      subtitle: "Manage and analyze trades",
      newTrade: "New Trade",
      addTrade: "Add Trade",
      searchPairPlaceholder: "Search pair...",
      noTradesFiltered: "No trades found with selected filters",
      noTradesYet: "No trades recorded yet",
      notesPlaceholder: "Trade notes...",
      editTrade: "Edit Trade",
      tradeDetails: "Trade Details",
      pair: "Pair",
      type: "Type",
      direction: "Direction",
      orderType: "Order Type",
      entryPrice: "Entry Price",
      exitPrice: "Exit Price",
      stopLoss: "Stop Loss",
      takeProfit: "Take Profit",
      lotSize: "Lot Size",
      pips: "Pips",
      profitLoss: "P/L",
      rMultiple: "R Multiple",
      commission: "Commission",
      swap: "Swap",
      fees: "Fees",
      slippage: "Slippage",
      entryDate: "Entry Date",
      exitDate: "Exit Date",
      session: "Session",
      strategy: "Strategy",
      setup: "Setup",
      market: "Market",
      limit: "Limit",
      stop: "Stop",
      asia: "Asia",
      london: "London",
      ny: "New York",
      overlap: "Overlap",
      importedFromMt: "This data is imported from MetaTrader",
      userInputHint: "You enter this data",
      ticket: "Ticket",
      duration: "Duration",
      marketCondition: "Market Condition",
      quantitativeData: "Quantitative Data (Auto from MT)",
      qualitativeData: "Qualitative Data (Your Input)",
      clickToExpand: "Click to view details",
      viewDetails: "View Details",
      disciplineScore: "Discipline Score",
      slTpAdjustment: "SL/TP Adjustment",
      finalOutcome: "Final Outcome",
      priceReversalIllusion: "Price Reversal Illusion",
      strategyUsed: "Strategy Used",
      lessonsLearned: "Lessons Learned",
      connectMetaTrader: "Connect MetaTrader to receive trades",
      webhookUrl: "Webhook URL",
      openPositions: "Open Positions",
      closedPositions: "Closed Positions",
      floatingPnl: "Floating P/L",
      realizedPnl: "Realized P/L",
      eventTimeline: "Event Timeline",
      platform: "Platform",
      webhookSecret: "Webhook Secret",
    },
    // Psychology & Qualitative
    psychology: {
      title: "Trade Psychology",
      emotionOpen: "Emotion at Entry",
      emotionClose: "Emotion at Exit",
      reasonOpen: "Reason for Entry",
      reasonClose: "Reason for Exit",
      reasonOpenPlaceholder: "Why did you enter this trade?",
      reasonClosePlaceholder: "Why did you exit this trade?",
      followedPlan: "Followed the Plan?",
      mistakes: "Mistakes",
      mistakesPlaceholder: "What mistakes did you make?",
      lessons: "Lessons Learned",
      satisfaction: "Satisfaction Level",
      confidence: "Confidence Level",
      stress: "Stress Level",
      fomo: "Fear of Missing Out (FOMO)",
      revenge: "Was it Revenge Trading?",
      overtrading: "Was it Overtrading?",
      emotionScale: {
        veryBad: "Very Bad",
        bad: "Bad",
        neutral: "Neutral",
        good: "Good",
        veryGood: "Very Good",
      },
      reflection: "Reflection & Analysis",
      whatWorked: "What Worked?",
      whatDidntWork: "What Didn't Work?",
      improvement: "Areas for Improvement",
    },
    // Risk Management
    risk: {
      title: "Risk Management",
      subtitle: "Calculate and control risk",
      positionCalculator: "Position Size Calculator",
      accountBalance: "Account Balance",
      riskPercent: "Risk (%)",
      riskAmount: "Risk Amount",
      stopDistance: "Stop Distance (pips)",
      positionSize: "Position Size",
      potentialLoss: "Potential Loss",
      potentialProfit: "Potential Profit",
      riskReward: "Risk/Reward Ratio",
      portfolioHeat: "Portfolio Heat",
      portfolioStatus: "Portfolio Status",
      maxDailyLoss: "Max Daily Loss",
      maxWeeklyLoss: "Max Weekly Loss",
      openPositions: "Open Positions",
      totalOpenRisk: "Total Open Risk",
      kellyFraction: "Kelly Criterion",
      kellyRecommended: "Half Kelly (Recommended)",
      kellyNote: "Kelly Criterion is calculated based on your historical performance. Using half Kelly is recommended for more conservative risk management.",
      calculate: "Calculate",
      suggestedSize: "Suggested Position Size",
      riskWarning: "High Risk Warning!",
      riskWarningText: "Total open trades risk",
      pair: "Pair",
      entryPrice: "Entry Price",
      avgWinLoss: "Avg Win/Loss Ratio",
    },
    // Analytics
    analytics: {
      title: "Analytics",
      subtitle: "In-depth trade analysis and performance",
      byStrategy: "By Strategy",
      bySession: "By Session",
      byDay: "By Weekday",
      bySymbol: "By Symbol",
      byEmotion: "By Emotion",
      winningTrades: "Winning Trades",
      losingTrades: "Losing Trades",
      breakeven: "Breakeven",
      streaks: "Streaks",
      bestTrade: "Best Trade",
      worstTrade: "Worst Trade",
      strategyPerformance: "Performance by Strategy",
      sessionPerformance: "Performance by Session",
      weekdayPerformance: "Performance by Weekday",
      noStrategy: "No Strategy",
      unknown: "Unknown",
      trades: "trades",
    },
    // Calendar
    calendar: {
      title: "Trading Calendar",
      subtitle: "Daily trading performance overview",
      daily: "Daily",
      weekly: "Weekly",
      monthly: "Monthly",
      tradesCount: "Trades Count",
      dayPnL: "Day P/L",
      totalR: "Total R",
      noTrades: "No trades to display",
    },
    // Strategies
    strategies: {
      title: "Strategy Library",
      subtitle: "Manage and view trading strategies",
      newStrategy: "New Strategy",
      checklist: "Checklist",
      entryRules: "Entry",
      exitRules: "Exit",
      timeframes: "Timeframes",
      examples: "Examples",
    },
    // Fundamentals
    fundamentals: {
      title: "Fundamentals",
      subtitle: "AI-Powered Market Fundamental Analysis",
      economicCalendar: "Economic Calendar",
      fedWatch: "Fed Watch",
      macroData: "Macro Data",
      news: "News",
      highImpact: "High Impact",
      mediumImpact: "Medium Impact",
      lowImpact: "Low Impact",
      marketOverview: "Market Overview",
      fredIndicators: "Federal Reserve Indicators",
      newsAnalysis: "News Analysis",
      aiOutlook: "AI Outlook",
      generateAnalysis: "Generate Analysis",
      refreshData: "Refresh",
      lastUpdated: "Last Updated",
      bullish: "Bullish",
      bearish: "Bearish",
      neutral: "Neutral",
      confidence: "Confidence",
      forex: "Forex",
      gold: "Gold",
      oil: "Oil",
      crypto: "Crypto",
      allMarkets: "All Markets",
      realtime: "Real-time",
      daily: "Daily",
      weekly: "Weekly",
      keyDrivers: "Key Drivers",
      risks: "Risks",
      predictions: "Predictions",
      target: "Target",
      support: "Support",
      resistance: "Resistance",
      rising: "Rising",
      declining: "Declining",
      stable: "Stable",
      hawkish: "Hawkish",
      dovish: "Dovish",
      strong: "Strong",
      weak: "Weak",
      geopoliticalRisks: "Geopolitical Risks",
      upcomingEvents: "Upcoming Events",
      tradingBias: "Trading Bias",
      buy: "Buy",
      sell: "Sell",
      hold: "Hold",
      noAnalysis: "No analysis yet",
      clickGenerate: "Click refresh to generate analysis",
      analyzing: "Analyzing...",
      errorLoading: "Error loading data",
      mockDataWarning: "FRED economic indicators using sample data (FRED API Key not configured)",
      newsIsReal: "News and AI analyses are fetched from real sources",
      // New tabs
      tabs: {
        fredIndicators: "Fed Indicators",
        calendarUSD: "USD Calendar",
        marketPrices: "Live Prices",
        centralBanks: "Central Banks",
        economicNews: "Economic News",
        wars: "Wars & Tensions",
        speeches: "Speeches",
        aiAnalysis: "AI Analysis",
      },
      // Market prices
      prices: {
        crypto: "Cryptocurrencies",
        indices: "Stock Indices",
        commodities: "Commodities",
        currencies: "Currencies",
      },
      // Central banks
      centralBanks: {
        title: "World Central Banks",
        rate: "Interest Rate",
        nextMeeting: "Next Meeting",
        stance: "Stance",
      },
      // Geopolitical
      geopolitical: {
        currentWars: "Current Wars",
        economicChallenges: "Economic Challenges",
        leaderSpeeches: "Leader Speeches",
        severity: "Severity",
        critical: "Critical",
        serious: "Serious",
        moderate: "Moderate",
        riskLevel: "Risk Level",
        increasing: "Increasing",
        decreasing: "Decreasing",
      },
      // Auto refresh
      autoRefresh: "Auto Refresh",
      autoRefreshEnabled: "Every 5 min",
      dataUpdated: "Data updated",
    },
    // Trade Assistant
    assistant: {
      title: "Trade Assistant",
      subtitle: "Connect to MetaTrader and execute trades",
      connectionStatus: "Connection Status",
      connected: "Connected",
      disconnected: "Disconnected",
      connecting: "Connecting...",
      mtAccount: "MetaTrader Account",
      syncTrades: "Sync Trades",
      lastSync: "Last Sync",
      pendingSync: "Pending Sync",
      importFromMT: "Import from MT",
      quantitativeData: "Quantitative Data (from MT)",
      qualitativeData: "Qualitative Data (your input)",

      connectionHelp: "To connect to MetaTrader, you need to install the EA Bridge on your trading platform.",
      connectToMt: "Connect to MT",
      connectionSettings: "Connection Settings",

      howItWorks: "How it Works",
      automatic: "Automatic",
      yourInput: "Your Input",

      autoItems: {
        entryExit: "Entry & Exit prices",
        slTp: "Stop Loss & Take Profit",
        lotSize: "Position size (lots)",
        pl: "P/L in dollars and pips",
        fees: "Commission, swap & fees",
        dateTime: "Trade date & time",
      },
      inputItems: {
        reasonEntry: "Reason for entry",
        reasonExit: "Reason for exit",
        emotions: "Emotions during trade",
        followedPlan: "Did you follow the plan?",
        mistakesLessons: "Mistakes & lessons",
        notesTags: "Notes & tags",
      },

      importTradesTitle: "Import Trades",
      importTradesDesc: "Until the MetaTrader connection is established, you can manually import trades from a CSV file.",
      importFromMt45: "Import from MT4/MT5",
      downloadCsvTemplate: "Download CSV Template",
      // New keys for Trade Assistant page
      openPositions: "Open Positions",
      noOpenPositions: "No open positions",
      connectAccount: "Connect Account",
      connectAccountMessage: "To use the Trade Assistant, first connect your MetaTrader account.",
      kpi: {
        dailyDD: "Daily DD",
        riskUtil: "Risk Util",
        margin: "Margin",
        heat: "Heat",
        nextNews: "Next News",
      },
      actions: {
        close: "Close",
        closePosition: "Close Position",
        reduce: "Reduce",
        reduce50: "Reduce 50%",
        protect: "Protect",
        protectBE: "Protect (BE)",
        modifySL: "Modify SL",
        modifyTP: "Modify TP",
      },
      modes: {
        title: "Autopilot Mode",
        safe: "Safe",
        discipline: "Discipline",
        adaptive: "Adaptive",
        pro: "Pro",
        custom: "Custom",
      },
      runbooks: {
        title: "Runbooks",
        drawdownSpike: "Drawdown Spike Safeguard",
        marginRescue: "Margin Rescue",
        newsLockdown: "News Lockdown",
        slProximity: "SL Proximity Guard",
        exposureControl: "Exposure Control",
        timeBasedExit: "Time-Based Exit",
      },
      killSwitch: {
        title: "Kill Switch",
        stage: "Stage",
        none: "None",
        stage1: "Stage 1",
        stage2: "Stage 2",
        trigger: "Trigger",
        reset: "Reset",
        lockedUntil: "Locked until",
        confirmTitle: "Trigger Kill Switch",
        confirmMessage: "This will close all open positions. Are you sure?",
      },
      logs: {
        title: "Action Logs",
        noEvents: "No events logged",
        queued: "Queued",
        executed: "Executed",
        runbook: "Runbook",
      },
      status: {
        normal: "Normal",
        watch: "Watch",
        danger: "Danger",
      },
      heat: {
        low: "Low",
        medium: "Med",
        high: "High",
      },
    },
    // Settings
    settings: {
      title: "Settings",
      subtitle: "Application & trading settings",
      language: "Language",
      theme: "Theme",
      dark: "Dark",
      light: "Light",
      auto: "Auto",
      timezone: "Timezone",
      currency: "Currency",
      accounts: "Accounts",
      backup: "Backup",
      restore: "Restore",
      exportData: "Export Data",
      importData: "Import Data",
      invalidFile: "Invalid file",
      backupRestoreTitle: "Backup & Restore",
      languages: {
        fa: "Persian",
        en: "English",
      },
      appSettingsTitle: "App Settings",
      timezoneLabel: "Timezone",
      timezoneDesc: "Default timezone for displaying dates",
      notifications: "Notifications",
      inAppNotif: "In-app notifications",
      emailNotif: "Email notifications",
      uiPreferences: "UI Preferences",
      compactMode: "Compact Mode",
      compactModeDesc: "Show tables and lists in a more compact view",
      tradingSettingsTitle: "Trading Settings",
      noActiveAccount: "Activate a Trading Account in Connections to see trading settings.",
      goToConnections: "Go to Connections",
      defaultRiskMode: "Default Risk Mode",
      fixedAmount: "Fixed Amount ($)",
      percentEquity: "% of Equity",
      defaultSymbol: "Default Symbol",
      defaultSymbolPlaceholder: "e.g., XAUUSD",
      slAlerts: "SL Alert Thresholds",
      slAlertsDesc: "Get alerted when price approaches a certain percentage of your stop loss",
      slAlert60: "Alert at 60% of SL",
      slAlert80: "Alert at 80% of SL",
      slAlert90: "Alert at 90% of SL",
      journalDefaults: "Journal Defaults",
      journalDefaultsDesc: "Default settings for new trade entries (coming soon)",
      importBehavior: "Trade Import Behavior",
      importBehaviorDesc: "How trades are imported from MetaTrader",
      closedOnly: "Closed trades only",
      closedOnlyDesc: "Currently only closed trades are imported from MetaTrader",
      saved: "Saved",
      settingsSaved: "Settings saved successfully",
      mtConnectionTitle: "MetaTrader Connection",
      mtConnectionDesc: "To connect to MetaTrader, visit the Connections page.",
      goToAssistant: "Go to Trade Assistant",
      mtConnectionSection: "MetaTrader Connection",
      webhookUrl: "Webhook URL",
      copyWebhookUrl: "Copy URL",
      userId: "User ID",
      copyUserId: "Copy ID",
      eaTemplate: "MetaTrader Expert Advisor Template",
      copyEaCode: "Copy EA Code",
      viewCode: "View Code",
      hideCode: "Hide Code",
      connectionStatus: "Connection Status",
      howItWorks: "How it Works",
      importTrades: "Import Trades",
      userIdDesc: "Your User ID (to link trades)",
      webhookDesc: "Use this URL in your MetaTrader EA.",
      eaDesc: "Copy this code into MetaEditor.",
      eaImportant: "Important: Add the webhook URL to allowed list.",
      examplePayload: "Example JSON payload",
      comingSoon: "Coming soon",
      goToMtSettings: "Go to MetaTrader Settings",
      lastSync: "Last Sync",
      totalSyncedTrades: "Total Synced Trades",
      neverSynced: "Never synced",
      checkingStatus: "Checking...",
      recentlyActive: "Active (last 24h)",
      inactive: "Inactive",
      refreshStatus: "Refresh Status",
      selectPlatform: "Select Platform",
      mt4Description: "For MetaTrader 4 (MQL4)",
      mt5Description: "For MetaTrader 5 (MQL5)",
      testConnection: "Test Connection",
      testConnectionDesc: "Sends a test trade to verify the webhook is working correctly",
    },
  },
};

export type Language = "fa" | "en";
export type TranslationKeys = typeof translations.fa;
